// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-image[data-v-79d11c03]{position:relative;text-align:center;padding:1px;min-height:300px}.page-image img[data-v-79d11c03]{max-height:600px}.page-loading[data-v-79d11c03]{top:0;bottom:0;height:50px}.page-loading[data-v-79d11c03],.paginator[data-v-79d11c03]{position:absolute;right:0;left:0;margin:auto}.paginator[data-v-79d11c03]{width:200px}", ""]);
// Exports
module.exports = exports;
